import React, { Component } from 'react';

class BackgroundImg extends Component {
    constructor(props){
        super(props);
    }

    render(){
        const { page_bg_image, show } = this.props;
        return (
            page_bg_image && show ?
            <div style={{
                backgroundImage: `url("${page_bg_image}")`,
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                padding: 0,
                zIndex: -1,
                overflow: 'visible'
            }}>
            </div>
            :
            <></>
        )
    }
}

export default BackgroundImg;